import { render } from "./Sidebar.vue?vue&type=template&id=115dbe90&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=115dbe90&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115dbe90"]])

export default __exports__